import { PARTNER_TYPE_LABEL, type PartnerType } from "@colab/shared";
import { cn } from "@/lib/utils";

export function PartnerTypeBadge({
  type,
  className,
}: {
  type: PartnerType;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border border-border/80 bg-secondary/60 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-muted-foreground",
        className,
      )}
    >
      {PARTNER_TYPE_LABEL[type]}
    </span>
  );
}
